import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { useTheme } from '../../ThemeContext';

import {
  dataSourceDeleteInit,
  dataSourceDelete,
} from '../../actions/DataSource/DataSourceActions';

import Modal from '../Modal';

import {
  Form,
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Button,
  Box,
  Textbox,
  Text,
  Deco,
} from './DataSourceDelete.style';

const DataSourceDeleteInner = ({
  data,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const { profile } = useSelector((state) => state.firebase);
  const isProfileCompany = profile.company && profile.company.id ? true : false;
  const { isLoading, isSuccess, isError, error } = useSelector(
    (state) => state.dataSourceDeleteStore
  );
  const dispatch = useDispatch();

  const onSubmit = (e) => {
    e.preventDefault();
    if (isProfileCompany) {
      dispatch(
        dataSourceDelete({
          id: data && data.id,
        })
      );
    }
  };

  useEffect(() => {
    dispatch(dataSourceDeleteInit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleProcess(isLoading ? true : false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSuccess, isError]);

  const renderSuccessPanel = () => {
    return (
      <Wrapper theme={theme.dataSourceDelete.wrapper}>
        <Header theme={theme.dataSourceDelete.header}>
          <Title theme={theme.dataSourceDelete.title}>
            {intl.formatMessage({
              id: 'DELETE_DATA_SOURCE.SUCCESS',
            })}
          </Title>
        </Header>
        <Content>
          <Box>
            <Textbox center>
              <Text theme={theme.dataSourceDelete.text.default}>
                {intl.formatMessage({
                  id: `DELETE_DATA_SOURCE.TEXT.THE_DATA_SOURCE_HAS_BEEN_SUCCESSFULLY_DELETED`,
                })}
              </Text>
            </Textbox>
          </Box>
        </Content>
        <Footer>
          <Button
            type='button'
            theme={theme.button.default}
            onClick={() => handleClose()}
          >
            {intl.formatMessage({ id: 'DELETE_DATA_SOURCE.OK' })}
          </Button>
        </Footer>
      </Wrapper>
    );
  };

  const renderFormPanel = () => {
    return (
      <Form onSubmit={onSubmit}>
        <Wrapper theme={theme.dataSourceDelete.wrapper}>
          <Header theme={theme.dataSourceDelete.header}>
            <Title theme={theme.dataSourceDelete.title}>
              {intl.formatMessage({
                id: 'DELETE_DATA_SOURCE.DELETE_DATA_SOURCE',
              })}
            </Title>
          </Header>
          <Content>
            <Box>
              <Textbox center>
                <Text theme={theme.dataSourceDelete.text.default}>
                  {intl.formatMessage(
                    {
                      id: `DELETE_DATA_SOURCE.TEXT.ARE_YOU_SURE_WANT_TO_DELETE_DATA_SOURCE`,
                    },
                    {
                      deco: (children) => (
                        <Deco theme={theme.dataSourceDelete.text.deco}>
                          {children}
                        </Deco>
                      ),
                      name: data && data.name,
                    }
                  )}
                  <br />
                  {intl.formatMessage({
                    id: `DELETE_DATA_SOURCE.TEXT.THIS_OPERATION_CANNOT_BE_UNDONE`,
                  })}
                </Text>
              </Textbox>
            </Box>
          </Content>
          {isError ? (
            <Textbox>
              <Text theme={theme.dataSourceDelete.text.error}>
                {intl.formatMessage({
                  id: `DELETE_DATA_SOURCE.TEXT.ERROR.${error}`,
                  defaultMessage: error,
                })}
              </Text>
            </Textbox>
          ) : (
            ''
          )}
          <Footer>
            <Button
              type='button'
              theme={theme.button.alt}
              disabled={isLoading}
              onClick={() => handleClose()}
            >
              {intl.formatMessage({ id: 'DELETE_DATA_SOURCE.CANCEL' })}
            </Button>
            <Button theme={theme.button.default} disabled={isLoading}>
              {isLoading
                ? intl.formatMessage({ id: 'DELETE_DATA_SOURCE.PLEASE_WAIT' })
                : intl.formatMessage({
                    id: `DELETE_DATA_SOURCE.DELETE`,
                  })}
            </Button>
          </Footer>
        </Wrapper>
      </Form>
    );
  };

  return <>{isSuccess ? renderSuccessPanel() : renderFormPanel()}</>;
};

const DataSourceDelete = ({
  data,
  handleClose = () => {},
  handleProcess = () => {},
}) => {
  return (
    <Modal handleClose={() => handleClose()}>
      <DataSourceDeleteInner
        data={data}
        handleClose={() => handleClose()}
        handleProcess={() => handleProcess()}
      />
    </Modal>
  );
};

DataSourceDeleteInner.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

DataSourceDelete.propTypes = {
  data: PropTypes.object,
  handleClose: PropTypes.func,
  handleProcess: PropTypes.func,
};

export default DataSourceDelete;
